module.exports = __webpack_public_path__ + "static/media/featured-badge.bc6d7663.svg";